import { useIntl } from 'react-intl';

import { Button } from '@xing-com/button';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import { TrackingLink } from '../../tracking-link';

import {
  Container,
  Illustration,
  TitleHandheld,
  TitleDesktop,
  Text,
} from './footer-section.styles';

export const FooterSection: React.FC = () => {
  const { isLoggedOut } = useLoginState();
  const { formatMessage } = useIntl();
  const isMobile = useMediaListener() === BREAKPOINTS.handheld;

  if (!isLoggedOut) {
    return null;
  }

  return (
    <Container>
      <Illustration />
      {isMobile ? (
        <TitleHandheld size="xlarge">
          {formatMessage({ id: 'CAREER_HUB_FOOTER_HEADLINE' })}
        </TitleHandheld>
      ) : (
        <TitleDesktop size="small" forwardedAs="h2">
          {formatMessage({ id: 'CAREER_HUB_FOOTER_HEADLINE' })}
        </TitleDesktop>
      )}
      <Text size="xlarge" lineHeight="increased">
        {formatMessage({ id: 'CAREER_HUB_FOOTER_BODYCOPY' })}
      </Text>
      <TrackingLink
        as={Button}
        url="/jobs"
        trackingParams={{
          sc_o: 'career_hub_application_home_job_search_button_click',
        }}
        variant="primary"
        size="large"
      >
        {formatMessage({ id: 'CAREER_HUB_FOOTER_BUTTON' })}
      </TrackingLink>
    </Container>
  );
};
